import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { PlantillaMemo } from '../models/PlantillaMemo';

@Injectable({
  providedIn: 'root'
})
export class PlantillasMemosService {

  private LIST_PLANTILLAS_MEMOS = environment.apiUrl + "pm/list"
  private CREATE_PLANTILLA_MEMO_URL = environment.apiUrl + "pm"
  private PATCH_PLANTILLA_MEMO_URL = environment.apiUrl + "pm/"

  constructor(
    private httpClient: HttpClient
  ) { }

  listConfigurationParameters(): Observable<PlantillaMemo[]> {
    return this.httpClient.get<PlantillaMemo[]>(this.LIST_PLANTILLAS_MEMOS)
  }

  create(plantillaMemo: PlantillaMemo): Observable<PlantillaMemo> {
    return this.httpClient.post<PlantillaMemo>(this.CREATE_PLANTILLA_MEMO_URL, plantillaMemo)
  }

  patch(plantillaMemo: PlantillaMemo): Observable<PlantillaMemo> {
    return this.httpClient.patch<PlantillaMemo>(this.PATCH_PLANTILLA_MEMO_URL + plantillaMemo.codigoPtlMemo, plantillaMemo)
  }
}
